import { IFloorDetails } from '@api'
import { ITreeNode } from '@blueprintjs/core'
import forEach from 'lodash/forEach'
import { LocationNodeType } from './renderTreeContents'

export type LocationTreeNodeT = ITreeNode<{
  nodeType: LocationNodeType
  floor?: IFloorDetails
  city?: {
    state: string
    name: string
  }
  building?: {
    isBuildingHidden: boolean
    name: string
    address: string
    city: string
    state: string
  }
}>

const forEachNode = (callback: (node: LocationTreeNodeT) => void, nodes?: LocationTreeNodeT[]) => {
  if (!nodes) {
    return
  }

  forEach<LocationTreeNodeT>(nodes, (node) => {
    callback(node)
    forEachNode(callback, node.childNodes)
  })
}

export default forEachNode
